import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { SpringDatatablePagination } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { DatatableService } from '../../../../shared/services/datatable.service';
import { SpringDatatablePaginationService } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { GestaoBeneficarioService } from './gestao-beneficiario.service';
import { ExportCsvService } from '../../../../shared/services/export-csv.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { ModalCofirmacaoComponent } from '../../../../shared/components/modal-confirmacao/modal-confirmacao.component';
import { ModalNovoBeneficiarioComponent } from './modal-novo-beneficiario/modal-novo-beneficiario.component';
import { DocumentoHelper } from '../../../../shared/utils/documento.helper';

@Component({
    selector: 'ngx-gestao-beneficiario',
    templateUrl: './gestao-beneficiario.component.html',
    styleUrls: ['./gestao-beneficiario.component.scss']
})
export class GestaoBeneficiarioComponent implements OnInit, OnDestroy {

    spinnerLoad: boolean = false;
    tableLimit = 10;
    public formSearch: FormGroup = null;

    @ViewChild('myTable', null)
    public myTable: DatatableComponent;
    public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();
    public customLogin = null;
    public cnpjCpf = null;

    constructor(
        private datatableService: DatatableService,
        private service: GestaoBeneficarioService,
        private formBuilder: FormBuilder,
        private paginationService: SpringDatatablePaginationService,
        private router: Router,
        private notificationService: NotificationsService,
        private exportCsvService: ExportCsvService,
        private spinnerService: NgxSpinnerService,
        private dialogService: NbDialogService,
    ) {
        this.paginationService.setDatatablePagination(this.datatablePagination);
    }

    ngOnInit() {

        let resCustom = localStorage.getItem('bway-customLogin');
        this.customLogin = JSON.parse(resCustom);
        document.title = this.customLogin.title;
        this.datatableService.subscribeTable(this.myTable);

        this.instanciarForm();

        this.getBeneficiarios(this.formSearch.value);

    }

    ngOnDestroy() {
        this.datatableService.unsubscribeTable(this.myTable);
    }

    instanciarForm() {
        this.formSearch = this.formBuilder.group({
            cnpj: [null],
            razaoSocial: [null],
        });

        this.datatablePagination.rowData = [];
        this.datatablePagination.currentPage = 0;
        this.datatablePagination.totalPages = 0;
        this.datatablePagination.totalElements = 0;
        this.datatablePagination.tableLimit = 0;
    }

    getBeneficiarios(data?: any, page?: string | number) {
        if (page == null || page == '') {
            this.spinnerService.show();
        }

        let params = this.getHttpParams(data, page);
        params = params.append('size', String(this.tableLimit));

        this.service.getBeneficiarios(params, (response) => {
            this.paginationService.setInfo(response);
            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            this.notificationService.error(error.message);
        });
    }

    exportarBeneficiariosCSV(data?: any) {
        this.spinnerService.show();
        let params = this.getHttpParams(data, null);
        params = params.append('size', String('9999'));

        this.service.getBeneficiarios(params, (response) => {

            if (response.content.length === 0) {
                this.spinnerService.hide();
                this.notificationService.warn('Não há dados para exportar!');
            } else {
                const columns = [
                    { columnName: 'cnpj', newColumnName: 'CNPJ' },
                    { columnName: 'razaoSocial', newColumnName: 'RAZÃO SOCIAL' },
                    { columnName: 'nomeFantasia', newColumnName: 'NOME FANTASIA' },

                ];

                const dados = response.content.map(dado => {
                    return {
                        cnpj: this.formatarDocumento(dado.cnpj),
                        razaoSocial: dado.razaoSocial,
                        nomeFantasia: dado.nomeFantasia,
                    };
                });

                this.exportCsvService.exportCsv(dados, columns, ';', 'beneficiarios_vale_estar_bem');
                this.spinnerService.hide();
            }

        }, (error) => {
            this.spinnerService.hide();
            this.notificationService.error(error.message);
        });

    }

    getHttpParams(data?: any, page?: string | number) {
        let params = new HttpParams();
        params = params.append('sort', 'id,asc');

        if (page !== null && page !== undefined && page !== '') {
            params = params.append('page', String(page));
        }

        if (data) {
            if (data.cnpj != null && data.cnpj !== '') {
                const cnpjNorm = this.normalizarCnpjCpfParaBackend(data.cnpj);
                if (cnpjNorm !== '') {
                    params = params.append('cnpj', cnpjNorm);
                }
            }
            if (data.razaoSocial != null && data.razaoSocial != '') {
                params = params.append('razaoSocial', data.razaoSocial);
            }
        }

        return params;
    }

    deleteBeneficiario(id){
        this.service.delBeneficiario(id,
            _response=>{
                this.notificationService.success("Beneficiário inativado!");
                this.getBeneficiarios(this.formSearch.value);
            },
            _error=>{
                this.notificationService.error("Erro ao inativar beneficiário!")
            });
    }


    previousPage() {
        this.router.navigate(['/iot-dashboard']);
    }

    getButtonPrimaria() {
        if (this.customLogin != null) {
            return this.customLogin.primaria;
        }
    }

    getButtonSecundaria() {
        if (this.customLogin != null) {
            return this.customLogin.secundaria;
        }
    }

    getButtonTerciario() {
        if (this.customLogin != null) {
            return this.customLogin.terciario;
        }
    }

    goToNovo() {
        const dialogRef = this.dialogService.open(ModalNovoBeneficiarioComponent);

        dialogRef.componentRef.instance.confirmaNovoEmitter.subscribe(() => {
            this.getBeneficiarios(this.formSearch.value);
            dialogRef.close()
        })

    }

    goToConfirma(id) {
        const dialogRef: NbDialogRef<ModalCofirmacaoComponent> = this.dialogService.open(ModalCofirmacaoComponent);
        dialogRef.componentRef.instance.confirmaEmitter.subscribe(()=>{
                this.deleteBeneficiario(id);
                dialogRef.close();
            }
        )
    }

    getCpfCnpjMask(): string {
        return DocumentoHelper.getMascaraCpfCnpj(this.cnpjCpf);
    }

    formatarDocumento(valor: string | null | undefined): string {
        return DocumentoHelper.formatarDocumento(valor);
    }

    private normalizarCnpjCpfParaBackend(value: any): string {
        if (value == null) {
            return '';
        }
        const str = String(value);
        if (str === '') {
            return '';
        }
        const tipo = DocumentoHelper.detectarTipoDocumento(str);
        return DocumentoHelper.normalizarParaEnvio(str, tipo);
    }
}
